import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ImportWizardComponent } from './import-wizard/import-wizard.component';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { MaterialModule } from '../common/material/material.module';
import { ServiceModule } from '../service/service.module';
import { FormsModule } from '@angular/forms';
import {
    WarningTransformationLogItemComponent,
} from './import-wizard/warning-transformationlogitem/warning-transformation-log-item.component';
import { ImportReportDisplayComponent } from './importreport-display/import-report-display.component';
import { NonEmptyLogPipe } from './importreport-display/non-empty-log.pipe';
import { WarningImportLogItemComponent } from './import-wizard/warning-importlogitem/warning-import-log-item.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { PipeModule } from '../common/pipe/pipe.module';
import {
    ErrorTransformationLogItemComponent,
} from './import-wizard/error-transformationlogitem/error-transformation-log-item.component';
import { ErrorImportLogItemComponent } from './import-wizard/error-importlogitem/error-import-log-item.component';
import { FormComponentsModule } from '../common/form/components/form-components.module';

@NgModule({
    declarations: [
        ImportWizardComponent,
        WarningTransformationLogItemComponent,
        ErrorTransformationLogItemComponent,
        ImportReportDisplayComponent,
        NonEmptyLogPipe,
        ErrorImportLogItemComponent,
        WarningImportLogItemComponent,
    ],
    imports: [
        CommonModule,
        MaterialModule,
        ServiceModule,
        FormsModule,
        MatProgressSpinnerModule,
        FormComponentsModule,
        PipeModule,
    ],
    providers: [
        provideHttpClient(withInterceptorsFromDi()),
    ],
})
export class ImportWizardModule {
}
